/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-28 13:59:38
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-28 15:04:31
 */

import * as request from '@/utils/request'

export default {
  /**
   * getContractList
   * @description 合同列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getContractList(data) {
    return request.post('/contract/list', data)
  },
  /**
   * saveContract
   * @description 保存合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveContract(data) {
    return request.post('/contract/store', data)
  },
  /**
   * getContractInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getContractInfo(id) {
    let data = {id:id}
    return request.post('/contract/get_info', data)
  },
  /**
   * deleteContract
   * @description 删除合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteContract(id) {
    let data = {id:id}
    return request.post('/contract/delete', data)
  },
  /**
   * @description 获取分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getContractCategoryList() {
    return request.post('/contract/category_list')
  },
}